export default "__VITE_ASSET__Dk1qsD3K__"